<template>
  <div>
    <div
      class="page-header clear-filter d-flex justify-content-center align-items-center"
      filter-color="dark"
    >
      <parallax
        class="page-header-image"
        style="background-color:#26a23e"
      ></parallax>
      <div class="content-center">
        <div class="container">
          <div class="content-center brand">
            <h1 class="h1-seo">Términos y Condiciones</h1>
          </div>
        </div>
      </div>
      <vue-particles
        color="#bbbbbb"
        :particleOpacity="0.5"
        :lineOpacity="0.3"
        :clickEffect="false"
      ></vue-particles>
    </div>

    <div class="section">
      <div class="features">
        <div class="container">
          <div class="row">
            <div class="col-12 text-justify">
              <main class="notion">
                <p class="notion-text">
                  Última actualización: 4 de abril de 2024
                </p>
                <p class="notion-text">
                  Bienvenido a Eficiencia Energética y Seguridad S.A de C.V. ("nosotros", "nos", "nuestro"). Operamos esta
                  plataforma y cualquier otro producto y servicio relacionado
                  que haga referencia o enlace a estos términos legales.
                </p>
                <p class="notion-text">
                  Para contactarnos, envíe un correo electrónico a:
                  <a
                    href="mailto:info@proyectosees.com"
                    class="notion-link"
                    >info@proyectosees.com</a
                  >
                </p>
                <p class="notion-text">
                  Al acceder y utilizar nuestros Servicios, usted acepta estar
                  sujeto a estos Términos Legales, constituyendo un acuerdo
                  legalmente vinculante entre usted y Eficiencia Energética y Seguridad S.A de C.V. Si no está de acuerdo, debe cesar el uso de
                  nuestros Servicios inmediatamente.
                </p>
                <p class="notion-text">
                  Nos reservamos el derecho de modificar estos Términos Legales
                  en cualquier momento, siendo su responsabilidad revisarlos
                  periódicamente.
                </p>
                <h3 class="notion-h1">1. NUESTROS SERVICIOS</h3>
                <p class="notion-text">
                  <b
                    >Eficiencia Energética y Seguridad S.A de C.V, </b>a ofrece una plataforma digital
                  que sirve como intermediario para conectar clientes con
                  profesionales independientes especializados en servicios de
                  mantenimiento del hogar. Aunque llevamos a cabo un riguroso
                  proceso de selección y verificación de las credenciales de los
                  profesionales registrados, actuamos únicamente como agencia
                  intermediaria. Las responsabilidades civiles y las garantías
                  relacionadas con los trabajos son exclusivas de los
                  profesionales independientes. Ofrecemos un canal dentro de la
                  plataforma para facilitar la resolución de disputas entre
                  clientes y profesionales, promoviendo una comunicación
                  efectiva y la búsqueda de soluciones satisfactorias. La
                  información proporcionada a través de los Servicios no está
                  destinada a ser distribuida ni utilizada por ninguna persona o
                  entidad en jurisdicciones donde dicha distribución o uso sería
                  ilegal.
                </p>
                <p class="notion-text">
                  Naturaleza del Servicio: Eficiencia Energética y Seguridad S.A de C.V,
                  actúa únicamente como plataforma intermediaria que facilita la
                  conexión entre clientes y profesionales independientes de
                  servicios de mantenimiento del hogar, como fontaneros,
                  electricistas, etc. Aclararemos que estos profesionales no son
                  empleados de nuestra empresa, sino contratistas independientes
                  responsables de proporcionar sus propios servicios.
                </p>
                <p class="notion-text">
                  Calidad del Servicio: La empresa no garantiza ni asegura la
                  calidad, seguridad, legalidad o cualquier otro aspecto de los
                  servicios proporcionados por los contratistas independientes.
                  Aunque realizamos esfuerzos para verificar las credenciales y
                  antecedentes de los profesionales, la responsabilidad final de
                  la selección y satisfacción del servicio recae sobre el
                  usuario.&nbsp; Los servicios se proporcionan tal cual y según
                  disponibilidad. Usted acepta que el uso de los servicios será
                  bajo su propio riesgo. En la medida máxima permitida por la
                  ley, renunciamos a todas las garantías, expresas o implícitas,
                  en relación con los servicios y su uso de los mismos,
                  incluyendo, sin limitación, las garantías implícitas de
                  comerciabilidad, idoneidad para un propósito particular y no
                  infracción. No ofrecemos garantías ni declaraciones sobre la
                  exactitud o integridad del contenido de los servicios o el
                  contenido de cualquier sitio web o aplicación móvil vinculada
                  a los servicios y no asumiremos ninguna responsabilidad por
                  cualquier (1) error, error o imprecisión del contenido y
                  materiales, (2) lesiones personales o daños a la propiedad, de
                  cualquier naturaleza, que resulten de su acceso y uso de los
                  servicios, (3) cualquier no autorizado acceso o uso de
                  nuestros servidores seguros y/o toda la información personal
                  y/o financiera almacenada en ellos, (4) cualquier interrupción
                  o cese de transmisión hacia o desde los servicios, (5)
                  cualquier error, virus, caballos de troya, o similares que
                  puedan ser transmitidos a o a través de los servicios por
                  cualquier tercero, y/o (6) cualquier error u omisión en
                  cualquier contenido y material o por cualquier pérdida o daño
                  de cualquier tipo incurrido como resultado del uso de
                  cualquier contenido publicado, transmitido o disponible de
                  otra manera a través de los servicios. No garantizamos,
                  respaldamos ni asumimos responsabilidad por ningún producto o
                  servicio anunciado u ofrecido por un tercero a través de los
                  servicios, cualquier sitio web hipervínculo o cualquier sitio
                  web o aplicación móvil presentado en cualquier banner u otra
                  publicidad, y no ser parte o de alguna manera ser responsable
                  de supervisar cualquier transacción entre usted y cualquier
                  tercero proveedor de productos o servicios. Al igual que con
                  la compra de un producto o servicio a través de cualquier
                  medio o en cualquier entorno, usted debe usar lo mejor que
                  pueda juicio y tenga precaución cuando corresponda.
                </p>
                <p class="notion-text">
                  Garantías: Los servicios a través de nuestra plataforma se
                  proporcionan "tal cual" y "según disponibilidad". Renunciamos
                  expresamente a todas las garantías de cualquier tipo, ya sean
                  expresas o implícitas, incluidas, pero no limitadas a, las
                  garantías implícitas de comerciabilidad, idoneidad para un
                  propósito particular y no infracción.
                </p>
                <p class="notion-text">
                  Tarifas Y Pagos: La plataforma podrá establecer tarifas por el
                  uso de algunos de sus servicios o funcionalidades. Toda
                  modificación a la estructura de tarifas será comunicada a los
                  usuarios con la debida antelación. Los pagos realizados a
                  través de la plataforma se procesarán de manera segura y de
                  acuerdo con los términos de servicio de los procesadores de
                  pago.
                </p>
                <h3 class="notion-h1">2. DERECHOS DE PROPIEDAD INTELECTUAL</h3>
                <p class="notion-text">
                  Somos propietarios o licenciatarios de todos los derechos de
                  propiedad intelectual de nuestros Servicios, incluidos el
                  código fuente, bases de datos, funcionalidad, software,
                  diseños de sitios web, y más. Nuestro contenido y marcas están
                  protegidos por leyes de derechos de autor, marcas registradas
                  y otros derechos de propiedad intelectual. El uso de nuestro
                  contenido y marcas está permitido únicamente para fines
                  personales, no comerciales o internos, y cualquier otro uso
                  requiere nuestro permiso expreso por escrito. El Contenido y
                  las Marcas se proporcionan en o a través de los Servicios.
                  "COMO ES" para su uso personal, no comercial o propósito
                  comercial interno solo.
                </p>
                <p class="notion-text">
                  Sujeto a su cumplimiento de estos Términos legales, incluido
                  ACTIVIDADES únicamente para su uso personal, no comercial o
                  propósito comercial interno. Excepto lo establecido en esta
                  sección o en otra parte de nuestros Términos legales, ninguna
                  parte de los Servicios ni ningún Contenido o Marcas pueden
                  copiarse, reproducirse, agregarse, republicarse, cargarse,
                  publicarse, mostrarse públicamente, codificarse, traducirse,
                  transmitirse, distribuirse o venderse., licenciado o explotado
                  de otro modo para cualquier fin comercial, sin nuestro permiso
                  previo expreso por escrito.
                </p>
                <h3 class="notion-h1">3. DECLARACIONES DEL USUARIO</h3>
                <p class="notion-text">
                  Al utilizar los Servicios, usted declara que tiene la
                  capacidad legal para aceptar estos Términos, no es menor de
                  edad en su jurisdicción, no accederá a los Servicios mediante
                  medios automatizados o no humanos, no utilizará los Servicios
                  para fines ilegales o no autorizados, y su uso de los
                  Servicios no violará ninguna ley o regulación aplicable.
                </p>
                <p class="notion-text">
                  Además el Usuario confirma que has leído y estás de acuerdo
                  con nuestra "ACTIVIDADES PROHIBIDAS" y no publicará,
                  enviará,&nbsp; cargará ni transmitirá a través de los
                  Servicios ninguna información que sea ilegal, acosador,
                  odioso, dañino, difamatorio, obsceno, intimidatorio, abusivo,
                  discriminatorio, amenazante para cualquier persona o grupo,
                  sexualmente explícito, falso, inexacto, o engañoso; en la
                  medida permitida por la ley aplicable, renunciar a todos y
                  cada uno de los derechos morales sobre dicho Envío; garantiza
                  que dicha presentación son originales para usted o que tiene
                  los derechos necesarios y licencias para presentar dicha
                  información, y que usted tiene plena autoridad para otorgarnos
                  los derechos antes mencionados en relación con lo que envíe;
                  garantiza y declara que sus Envíos no constituyen información
                  confidencial. Usted es el único responsable de la información
                  que comparte, y usted acepta expresamente reembolsarnos por
                  todas y cada una de las pérdidas que podamos sufrir debido a
                  su incumplimiento de (a) esta sección, (b) los derechos de
                  propiedad intelectual de cualquier tercero o (c) la ley
                  aplicable.
                </p>
                <h3 class="notion-h1">4. ACTIVIDADES PROHIBIDAS</h3>
                <p class="notion-text">
                  Usted se compromete a no realizar actividades prohibidas, como
                  la recuperación sistemática de datos de los Servicios para
                  crear una base de datos sin nuestro permiso, engañar o
                  defraudar a otros usuarios, eludir las medidas de seguridad de
                  los Servicios, hacer un uso indebido de nuestros servicios de
                  soporte, cargar o transmitir virus o material dañino, y
                  cualquier intento de realizar transacciones o contrataciones
                  fuera de la plataforma con profesionales independientes
                  registrados.
                </p>
                <p class="notion-text">
                  No puede acceder ni utilizar los Servicios para ningún
                  propósito distinto de aquel para el cual ponemos los Servicios
                  a disposición. Los Servicios no se pueden utilizar en relación
                  con ningún propósito comercial. Esfuerzos excepto aquellos que
                  estén específicamente respaldados o aprobados por nosotros.
                </p>
                <p class="notion-text">
                  Como usuario de los Servicios, usted acepta no:
                </p>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Recuperar sistemáticamente datos u otro contenido de los
                    Servicios para crear o compilar, directa o indirectamente,
                    una colección, compilación, base de datos o directorio sin
                    nuestro permiso por escrito.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Engañarnos, defraudarnos o engañarnos a nosotros y a otros
                    usuarios, especialmente en cualquier intento de conocer
                    información confidencial de la cuenta, como las contraseñas
                    de los usuarios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Eludir, deshabilitar o interferir de otro modo con las
                    funciones relacionadas con la seguridad de los Servicios,
                    incluidas las funciones que impiden o restringen el uso o la
                    copia de cualquier Contenido o imponen limitaciones en el
                    uso de los Servicios y/o el Contenido en ellos.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Menospreciar, empañar o dañar de otro modo, en nuestra
                    opinión, a nosotros y/o los Servicios. Utilizar cualquier
                    información obtenida de los Servicios para acosar, abusar o
                    dañar a otra persona.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Hacer un uso indebido de nuestros servicios de soporte o
                    enviar informes falsos de abuso o mala conducta. Usar los
                    Servicios de manera inconsistente con las leyes o
                    regulaciones aplicables.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Participar en no autorizado en marcar o vincular los
                    Servicios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Cargar o transmitir (o intentar cargar o transmitir) virus,
                    caballos de Troya u otro material, incluido el uso excesivo
                    de letras mayúsculas y spam (publicación continua de texto
                    repetitivo), que interfiera con el uso y disfrute
                    ininterrumpido de los Servicios o modifica, perjudica,
                    interrumpe, altera o interfiere con el uso, las
                    características, las funciones, la operación o el
                    mantenimiento de los Servicios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Participar en cualquier uso automatizado del sistema, como
                    el uso de scripts para enviar comentarios o mensajes, o el
                    uso de minería de datos, robots o herramientas similares de
                    recopilación y extracción de datos.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Eliminar el aviso de derechos de autor u otros derechos de
                    propiedad de cualquier Contenido.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Intentar hacerse pasar por otro usuario o persona o utilizar
                    el nombre de usuario de otro usuario.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Cargar o transmitir (o intentar cargar o transmitir)
                    cualquier material que actúe como un mecanismo de
                    transmisión o recopilación de información pasiva o activa,
                    incluidos, entre otros, formatos de intercambio de gráficos
                    claros ("gifs"), 1×1 píxeles, errores web, cookies u otros
                    dispositivos similares (a veces denominados "spyware" o
                    "mecanismos de recopilación pasiva" o "pcms").
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Interferir, interrumpir o crear una carga indebida en los
                    Servicios o las redes o servicios conectados a los
                    Servicios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Acosar, molestar, intimidar o amenazar a cualquiera de
                    nuestros empleados o agentes involucrados en brindarle
                    cualquier parte de los Servicios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Intentar eludir cualquier medida de los Servicios diseñada
                    para prevenir o restringir el acceso a los Servicios, o
                    cualquier parte de los Servicios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Copie o adapte el software de los Servicios, incluidos,
                    entre otros, Flash, PHP, HTML, JavaScript u otro código.
                    Excepto según lo permita la ley aplicable, descifrar,
                    descompilar, desensamblar o realizar ingeniería inversa en
                    cualquier software que comprenda o de alguna manera forme
                    parte de los Servicios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Excepto que pueda ser el resultado del uso de un motor de
                    búsqueda estándar o un navegador de Internet, use, inicie,
                    desarrolle o distribuya cualquier sistema automatizado,
                    incluidos, entre otros, cualquier araña, robot, utilidad de
                    trampa, raspador o lector fuera de línea que acceda a los
                    Servicios, o utilizar o iniciar cualquier script no
                    autorizado u otro software.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Utilice un agente o agentes de compras para realizar compras
                    en los Servicios.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Hacer cualquier uso no autorizado de los Servicios, incluida
                    la recopilación de nombres de usuario y/o direcciones de
                    correo electrónico de los usuarios por medios electrónicos o
                    de otro tipo con el fin de enviar correos electrónicos no
                    solicitados, o crear cuentas de usuario por medios
                    automatizados o bajo condiciones falsas, pretensiones.
                  </li>
                </ul>
                <ul class="notion-list notion-list-disc">
                  <li>
                    Usar los Servicios como parte de cualquier esfuerzo para
                    competir con nosotros o usar de otro modo los Servicios y/o
                    el Contenido para cualquier actividad generadora de
                    ingresos, empeño o empresa comercial.
                  </li>
                </ul>
                <h3 class="notion-h1">
                  5. CONTRIBUCIONES GENERADAS POR LOS USUARIOS
                </h3>
                <p class="notion-text">
                  Aunque los Servicios no están diseñados para que los usuarios
                  publiquen contenido, en caso de que se ofrezca esta
                  posibilidad, usted será responsable de sus contribuciones y
                  deberá asegurarse de que no infringen los derechos de terceros
                  ni las leyes aplicables.
                </p>
                <h3 class="notion-h1">6. CONTRIBUCIÓN DE LICENCIA</h3>
                <p class="notion-text">
                  Al enviar contribuciones a los Servicios, usted otorga a
                  Eficiencia Energética y Seguridad S.A de C.V a
                  una licencia para usar, compartir y explotar dichas
                  contribuciones de acuerdo con estos Términos.
                </p>
                <h3 class="notion-h1">7. GESTIÓN DE SERVICIOS</h3>
                <p class="notion-text">
                  Nos reservamos el derecho de monitorear los Servicios, tomar
                  acciones legales contra quienes violen estos Términos, y
                  administrar los Servicios para proteger nuestros derechos y
                  propiedad y asegurar su funcionamiento adecuado. Nos
                  reservamos el derecho, pero no la obligación, de:
                </p>
                <p class="notion-text">
                  (1) monitorear los Servicios para detectar violaciones de
                  estos Términos legales;
                </p>
                <p class="notion-text">
                  (2) tomar las acciones legales apropiadas contra cualquier
                  persona que, a nuestro exclusivo criterio, viole la ley o
                  estos Términos legales, incluido, entre otros, denunciar a
                  dicho usuario ante las autoridades encargadas de hacer cumplir
                  la ley;
                </p>
                <p class="notion-text">
                  (3) a nuestro exclusivo criterio y sin limitación, rechazar,
                  restringir el acceso, limitar la disponibilidad o desactivar
                  (en la medida en que sea tecnológicamente posible) cualquiera
                  de sus Contribuciones o cualquier parte de las mismas;
                </p>
                <p class="notion-text">
                  (4) a nuestro exclusivo criterio y sin limitación, aviso ni
                  responsabilidad, eliminar de los Servicios o deshabilitar de
                  otro modo todos los archivos y contenidos que tengan un tamaño
                  excesivo o que de alguna manera sean gravosos para nuestros
                  sistemas; y
                </p>
                <p class="notion-text">
                  (5) administrar los Servicios de una manera diseñada para
                  proteger nuestros derechos y propiedad y facilitar el
                  funcionamiento adecuado de los Servicios.
                </p>
                <p class="notion-text">
                  (6) Cualquier otro aspecto relacionado.
                </p>
                <h3 class="notion-h1">8. PLAZO Y TERMINACIÓN</h3>
                <p class="notion-text">
                  Estos Términos permanecen vigentes mientras utilice los
                  Servicios. Nos reservamos el derecho de terminar su acceso a
                  los Servicios por cualquier motivo, incluido el incumplimiento
                  de estos Términos.
                </p>
                <p class="notion-text">
                  Estos Términos legales permanecerán en pleno vigor y efecto
                  mientras utilice los Servicios. SIN LIMITAR CUALQUIER OTRA
                  DISPOSICIÓN DE ESTOS TÉRMINOS LEGALES, NOS RESERVAMOS EL
                  DERECHO DE, A NUESTRA DISCRECIÓN Y SIN AVISO NI
                  RESPONSABILIDAD, NEGAR EL ACCESO Y EL USO DE LOS SERVICIOS
                  (INCLUYENDO EL BLOQUEO DE CIERTAS DIRECCIONES IP), A CUALQUIER
                  PERSONA POR CUALQUIER RAZÓN O POR NINGÚN MOTIVO, INCLUYENDO,
                  SIN LIMITACIÓN, EL INCUMPLIMIENTO DE CUALQUIER DECLARACIÓN,
                  GARANTÍA O PACTO CONTENIDO EN ESTOS TÉRMINOS LEGALES O DE
                  CUALQUIER LEY O REGLAMENTO APLICABLE. PODEMOS TERMINAR SU USO
                  O PARTICIPACIÓN EN LOS SERVICIOS O ELIMINAR CUALQUIER
                  CONTENIDO O INFORMACIÓN QUE USTED PUBLICÓ EN CUALQUIER
                  MOMENTO, SIN PREVIO AVISO, A NUESTRA DISCRECIÓN EXCLUSIVA. Si
                  cancelamos o suspendemos su cuenta por cualquier motivo, tiene
                  prohibido registrarse y crear una nueva cuenta con su nombre,
                  un nombre falso o prestado, o el nombre de cualquier tercero,
                  incluso si puede estar actuando en nombre del tercero. fiesta.
                  Además de cancelar o suspender su cuenta, nos reservamos el
                  derecho de tomar las acciones legales apropiadas, incluidas,
                  entre otras, la búsqueda de reparación civil, penal y
                  judicial. 9. MODIFICACIONES E INTERRUPCIONES Nos reservamos el
                  derecho de cambiar, modificar o eliminar el contenido de los
                  Servicios en cualquier momento o por cualquier motivo a
                  nuestro exclusivo criterio y sin previo aviso. Sin embargo, no
                  tenemos obligación de actualizar ninguna información sobre
                  nuestros Servicios. No seremos responsables ante usted ni ante
                  ningún tercero por ninguna modificación, cambio de precio,
                  suspensión o interrupción de los Servicios.
                </p>
                <p class="notion-text">
                  No podemos garantizar que los Servicios estén disponibles en
                  todo momento. Es posible que experimentemos problemas de
                  hardware, software u otros problemas o necesitemos realizar
                  mantenimiento relacionado con los Servicios, lo que resultará
                  en interrupciones, demoras o errores. Nos reservamos el
                  derecho de cambiar, revisar, actualizar, suspender,
                  descontinuar o modificar de otro modo los Servicios en
                  cualquier momento o por cualquier motivo sin previo aviso.
                  Usted acepta que no tenemos responsabilidad alguna por
                  cualquier pérdida, daño o inconveniente causado por su
                  incapacidad para acceder o utilizar los Servicios durante
                  cualquier tiempo de inactividad o interrupción de los
                  Servicios. Nada en estos Términos legales se interpretará en
                  el sentido de obligarnos a mantener y respaldar los Servicios
                  o a proporcionar correcciones, actualizaciones o publicaciones
                  en relación con los mismos.
                </p>
                <h3 class="notion-h1">9. MODIFICACIONES E INTERRUPCIONES</h3>
                <p class="notion-text">
                  Nos reservamos el derecho de modificar, suspender o
                  descontinuar cualquier aspecto de los Servicios en cualquier
                  momento sin previo aviso.
                </p>
                <h3 class="notion-h1">10. LEY APLICABLE</h3>
                <p class="notion-text">
                  Estos Términos se rigen por las leyes de la jurisdicción en la
                  que se encuentra Eficiencia Energética y Seguridad S.A de C.V, y cualquier disputa será resuelta en sus
                  tribunales.
                </p>
                <h3 class="notion-h1">11. RESOLUCIÓN DE DISPUTAS</h3>
                <p class="notion-text">
                  Fomentamos la resolución de disputas a través de negociación
                  directa entre las partes. En caso de ser necesario, el
                  arbitraje será el método de resolución, sujeto a las leyes de
                  la jurisdicción aplicable. Las partes acuerdan que toda
                  disputa que surja será resuelta por medio de arbitraje en
                  derecho de conformidad con las reglas arbitrales del Centro de
                  Arbitraje de la Cámara de Comercio e Industria de El Salvador.
                  Las Partes acuerdan que cualquier arbitraje se limitará a la
                  Disputa entre las Partes individualmente. En la máxima medida
                  permitida por la ley, (a) ningún arbitraje se combinará con
                  ningún otro procedimiento; (b) no existe ningún derecho o
                  autoridad para que cualquier Disputa sea arbitrada sobre la
                  base de una demanda colectiva o para utilizar procedimientos
                  de demanda colectiva; y (c) no existe ningún derecho o
                  autoridad para que cualquier Disputa se presente en una
                  supuesta capacidad representativa en nombre del público en
                  general o de cualquier otra persona.
                </p>
                <h3 class="notion-h1">12. CORRECCIONES</h3>
                <p class="notion-text">
                  Nos reservamos el derecho de corregir errores, inexactitudes u
                  omisiones en los Servicios en cualquier momento sin previo
                  aviso.
                </p>
                <p class="notion-text">
                  Cambios en los Servicios: Nos reservamos el derecho de
                  modificar, suspender o descontinuar cualquier aspecto de
                  nuestra plataforma en cualquier momento, incluida la
                  disponibilidad de cualquier característica, base de datos o
                  contenido. No seremos responsables ante usted ni ante ningún
                  tercero por cualquier modificación, cambio de precio,
                  suspensión o interrupción del servicio.
                </p>
                <h3 class="notion-h1">13. DESCARGO DE RESPONSABILIDAD</h3>
                <p class="notion-text">
                  Los Servicios se proporcionan "tal cual", sin garantías de
                  ningún tipo. No seremos responsables por errores,
                  interrupciones o la transmisión de virus u otros elementos
                  dañinos a través de los Servicios.
                </p>
                <h3 class="notion-h1">14. LIMITACIONES DE RESPONSABILIDAD</h3>
                <p class="notion-text">
                  Nuestra responsabilidad se limitará en todo momento a la menor
                  de las cantidades: la pagada por usted a nosotros, o una
                  cantidad razonable.
                </p>
                <p class="notion-text">
                  Limitación de Daños: En ningún caso Ayuda Mantenimiento y
                  servicios, ni sus directores, empleados, socios, agentes,
                  proveedores o afiliados, serán responsables de daños
                  indirectos, incidentales, especiales, consecuentes o
                  punitivos, incluidos, sin limitación, la pérdida de
                  beneficios, datos, uso, buena voluntad u otras pérdidas
                  intangibles, resultantes de (i) su acceso a o uso de o
                  incapacidad para acceder o utilizar los servicios; (ii)
                  cualquier conducta o contenido de cualquier tercero en los
                  servicios; (iii) cualquier contenido obtenido de los
                  servicios; y (iv) acceso no autorizado, uso o alteración de
                  sus transmisiones o contenido, ya sea basado en garantía,
                  contrato, agravio (incluida la negligencia) o cualquier otra
                  teoría legal, ya sea que hayamos sido informados o no de la
                  posibilidad de tales daños.
                </p>
                <h3 class="notion-h1">15. INDEMNIZACIÓN</h3>
                <p class="notion-text">
                  Usted acuerda indemnizarnos contra cualquier pérdida, daño, o
                  gasto surgido de su uso de los Servicios o su incumplimiento
                  de estos Términos.
                </p>
                <p class="notion-text">
                  INDEMNIZACIÓN: Usted acuerda indemnizar, defender y eximir de
                  responsabilidad a Eficiencia Energética y Seguridad S.A de C.V, sus subsidiarias, afiliadas, socios,
                  oficiales, directores, agentes, contratistas, licenciantes,
                  proveedores de servicios, subcontratistas, proveedores,
                  internos y empleados, de cualquier reclamación o demanda,
                  incluyendo honorarios razonables de abogados, realizados por
                  un tercero debido a su incumplimiento de estos Términos de
                  Servicio o los documentos que incorporan por referencia, o su
                  violación de cualquier ley o los derechos de un tercero.
                </p>
                <h3 class="notion-h1">16. DATOS DEL USUARIO</h3>
                <p class="notion-text">
                  Somos responsables de mantener ciertos datos relacionados con
                  su uso de los Servicios, pero no seremos responsables por la
                  pérdida o corrupción de dichos datos.
                </p>
                <p class="notion-text">
                  USO DE DATOS Y PRIVACIDAD El uso de los Servicios por parte de
                  los usuarios puede implicar la recopilación, uso y
                  compartición de datos personales. Es importante que los
                  usuarios revisen nuestra Política de Privacidad, que se
                  incorpora a estos Términos Legales por referencia, para
                  entender nuestras prácticas. Al utilizar los Servicios, usted
                  consiente el tratamiento de sus datos conforme a dicha
                  política.
                </p>
                <p class="notion-text">
                  SEGURIDAD. La seguridad de su información personal es
                  importante para nosotros, pero recuerde que ningún método de
                  transmisión por Internet, o método de almacenamiento
                  electrónico, es 100% seguro. Mientras nos esforzamos por usar
                  medios comercialmente aceptables para proteger su información
                  personal, no podemos garantizar su seguridad absoluta.
                </p>
                <h3 class="notion-h1">
                  17. COMUNICACIONES, TRANSACCIONES Y FIRMAS ELECTRÓNICAS
                </h3>
                <p class="notion-text">
                  Usted acepta el uso de comunicaciones electrónicas para todos
                  los propósitos relacionados con los Servicios, incluyendo la
                  aceptación de estos Términos.
                </p>
                <h3 class="notion-h1">18. VARIOS</h3>
                <p class="notion-text">
                  Estos Términos constituyen el acuerdo completo entre usted y
                  nosotros. Cualquier disposición de estos Términos que sea
                  ilegal, nula o inaplicable se considerará separable, sin
                  afectar la validez y aplicabilidad de las disposiciones
                  restantes.
                </p>
                <p class="notion-text">
                  SOPORTE TÉCNICO Y ATENCIÓN AL CLIENTE Se establecerá un
                  servicio de soporte técnico y atención al cliente para
                  resolver cualquier duda, queja o sugerencia relacionada con el
                  uso de la plataforma. Este servicio estará disponible a través
                  de diversos canales de comunicación para asegurar una
                  respuesta oportuna y eficaz.
                </p>
                <p class="notion-text">
                  POLÍTICA DE CALIFICACIONES Y RESEÑAS Los usuarios tendrán la
                  posibilidad de calificar y dejar reseñas sobre los servicios
                  recibidos por parte de los profesionales independientes. Estas
                  calificaciones y reseñas deben ser honestas, verídicas y
                  respetuosas. Nos reservamos el derecho de eliminar aquellas
                  que consideremos fraudulentas, ofensivas o que violen nuestros
                  términos y condiciones.
                </p>
                <h3 class="notion-h1">
                  19. RESPONSABILIDADES DE LOS PROFESIONALES
                </h3>
                <p class="notion-text">
                  PROCEDIMIENTOS DE VERIFICACIÓN DE PROFESIONALES Eficiencia Energética y Seguridad S.A de C.V se compromete a
                  realizar un proceso de verificación detallado de los
                  profesionales independientes antes de su incorporación a la
                  plataforma. Este proceso incluirá la verificación de
                  antecedentes, certificaciones profesionales y referencias
                  laborales. Nos reservamos el derecho de rechazar o retirar a
                  cualquier profesional de la plataforma basándonos en los
                  resultados de estas verificaciones.
                </p>
                <p class="notion-text">
                  SEGUROS Y RESPONSABILIDAD CIVIL Los profesionales
                  independientes deben contar con un seguro de responsabilidad
                  civil vigente que cubra los daños o perjuicios que pudieran
                  derivarse de la ejecución de sus servicios. Eficiencia Energética y Seguridad S.A de C.V, no asume ninguna
                  responsabilidad por reclamaciones relacionadas con la ausencia
                  o insuficiencia de dichos seguros.
                </p>
                <h3 class="notion-h1">22. CONFIDENCIALIDAD Y DATOS</h3>
                <p class="notion-text">
                  CONFIDENCIALIDAD Y PROTECCIÓN DE DATOS Toda la información
                  personal proporcionada por los usuarios y profesionales será
                  tratada con estricta confidencialidad y conforme a la
                  legislación aplicable sobre protección de datos personales.
                  Nos comprometemos a implementar medidas de seguridad adecuadas
                  para proteger dicha información contra el acceso no
                  autorizado, la divulgación, alteración o destrucción.
                </p>
                <p class="notion-text">
                  DERECHOS SOBRE EL CONTENIDO GENERADO POR LOS USUARIOS Al
                  publicar, cargar, contribuir, o de cualquier manera poner a
                  disposición cualquier contenido en la plataforma (incluidos,
                  pero no limitados a, comentarios, opiniones, publicaciones,
                  testimonios, y fotografías), usted otorga a Eficiencia Energética y Seguridad S.A de C.V Empresa una licencia
                  mundial, perpetua, irrevocable, transferible, libre de
                  regalías y con derecho a sublicenciar para usar, copiar,
                  modificar, adaptar, publicar, traducir, crear obras derivadas,
                  distribuir, ejecutar y exhibir dicho contenido en todos los
                  medios conocidos o desarrollados en el futuro. Usted declara y
                  garantiza que posee o controla todos los derechos sobre el
                  contenido que publica, que el contenido es preciso, que el uso
                  del contenido que proporciona no viola esta política y no
                  causará daño a ninguna persona o entidad, y que indemnizará a
                  Eficiencia Energética y Seguridad S.A de C.V por
                  todas las reclamaciones resultantes del contenido que
                  suministra.
                </p>
                <div></div>
                <h3 class="notion-h1">23. CONTÁCTENOS</h3>
                <p class="notion-text">
                  Para resolver una queja sobre los Servicios o recibir más
                  información sobre el uso de los Servicios, contáctenos en:
                  <a
                    href="mailto:info@proyectosees.com"
                    class="notion-link"
                    >info@proyectosees.com</a
                  >
                </p>
              </main>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "terms",
  bodyClass: "terms-page",
  data() {
    return {
      social: {
        title: "Términos y Condiciones - Eficiencia Energética y Seguridad",
        description:
          "Somos una empresa que nace en 2015, ofrecemos consultoría, diseño, construcción, integración, mantenimiento integral y asistencia técnica en informática y tecnología.",
        image: "https://proyectosees.com/img/ees-icon.jpg",
      },
      current: 0,
      direction: 1,
      transitionName: "fade",
      show: false,
    };
  },
  mounted() {
    this.show = true;
  },
  head: {
    title: {
      inner: "Términos y Condiciones",
    },
    // Meta tags
    meta() {
      return [
        { n: "application-name", c: "Eficiencia Energética y Seguridad" },
        { n: "description", c: this.social.description, id: "desc" }, // id to replace intead of create element
        // ...
        // Twitter
        { n: "twitter:card", c: "summary" },
        // { n: 'twitter:site', c: '@username' },
        { n: "twitter:title", c: this.social.title },
        { n: "twitter:description", c: this.social.description },
        // { n: 'twitter:creator', c: '@username' },
        { n: "twitter:image", c: this.social.image },
        // Google+ / Schema.org
        { itemprop: "name", c: this.social.title },
        { itemprop: "description", c: this.social.description },
        { itemprop: "image", c: this.social.image },
        // Facebook / Open Graph
        { p: "og:title", c: this.social.title },
        { p: "og:type", c: "website" },
        { p: "og:url", c: "https://proyectosees.com/terms" },
        { p: "og:image", c: this.social.image },
        { p: "og:description", c: this.social.description },
        { p: "og:site_name", c: "Eficiencia Energética y Seguridad" },
        // { p: 'fb:app_id', c: '123456789' },
      ];
    },
  },
};
</script>
<style>
.section-product .info .icon > i {
  font-size: 2.5em;
}
.section-product .features img {
  max-height: 500px;
}

@media screen and (max-width: 767.87px) {
  .section-product .features img {
    max-height: 400px;
  }
}
</style>
